// Paged notification history for the full NotificationsPage.
//
// Deliberately a SEPARATE slice from the main `notifications` slice: the
// bell's 20s polling replaces that slice's items with the latest 50,
// which would fight the user's pagination/filter choices on this page.
const action = "NOTIFICATIONS_PAGE_LIST";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { page, perPage, unread }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
